
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sw/misc/app-markets",
      function () {
        return require("private-next-pages/sw/misc/app-markets/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sw/misc/app-markets"])
      });
    }
  